import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import useTranslate from '../../../core/languages/hooks/useTranslate';
import {getTransportReferenceLabel} from "../../utils/transportLabels";
import {TransportEnum} from "../../enums/TransferTransportEnum";
import InputField from "../../../ui/components/InputField/InputField";

const DepartureTransportCompanyAndNumber: React.FC = () => {
    const t = useTranslate();
    const { control, watch, formState: { errors } } = useFormContext();
    const departureTransport = watch("departureTransport");

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Controller
                name="departureTransportReference"
                control={control}
                rules={{
                    required: departureTransport !== TransportEnum.OTHER && departureTransport ? t('common.feedback.field_required') : false
                }}
                render={({ field }) => (
                    <InputField
                        {...field}
                        label={getTransportReferenceLabel(t, departureTransport, 'reference')}
                        type="text"
                        disabled={departureTransport === TransportEnum.OTHER || !departureTransport}
                        error={errors.departureTransportReference?.message}
                    />
                )}
            />
            <Controller
                name="departureTransportReferenceNumber"
                control={control}
                rules={{
                    required: departureTransport !== TransportEnum.OTHER && departureTransport ? t('common.feedback.field_required') : false
                }}
                render={({ field }) => (
                    <InputField
                        {...field}
                        label={getTransportReferenceLabel(t, departureTransport, 'number')}
                        type="text"
                        disabled={departureTransport === TransportEnum.OTHER || !departureTransport}
                        error={errors.departureTransportReferenceNumber?.message}
                    />
                )}
            />
        </div>
    );
};

export default DepartureTransportCompanyAndNumber;

